import { faEye } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FilterMatchMode } from "primereact/api";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { Tag } from "primereact/tag";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { offlineDeviceName } from "../redux/actions/offlineDeviceName";

const DeviceStatus = () => {
  const dispatch = useDispatch();
  const [offline, setOffline] = useState(null);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [expandedRows, setExpandedRows] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const offlineData = useSelector((state) => state.offlineDeviceNameReducer);
  const { role } = JSON.parse(localStorage.getItem("userData"));
  useEffect(() => {
    dispatch(offlineDeviceName());
  }, [dispatch]);

  useEffect(() => {
    if (offlineData?.data?.length) {
      setOffline(offlineData?.data);
      setIsLoading(false);
    }
  }, [offlineData]);

  useEffect(() => {
    if (offlineData?.loading) {
      setIsLoading(true);
    }
  }, [offlineData]);

  const statusColumnBody = (row) => {
    if (row?.deviceStatus === "Online") {
      return <Tag severity="success">Online</Tag>;
    } else if (row?.deviceStatus === "TemporaryOffline") {
      return <Tag severity="warning">Temporary Offline</Tag>;
    } else if (row?.deviceStatus === "LongTermOffline") {
      return <Tag style={{ background: "gray" }}>LongTerm Offline</Tag>;
    } else {
      return <Tag severity="danger">Offline</Tag>;
    }
  };

  const nodeStatusColumnBody = (row) => {
    if (row?.IOTStatus === "Online") {
      return <Tag severity="success">Online</Tag>;
    } else if (row?.IOTStatus === "TemporaryOffline") {
      return <Tag severity="warning">Temporary Offline</Tag>;
    } else if (row?.IOTStatus === "LongTermOffline") {
      return <Tag style={{ background: "gray" }}>LongTerm Offline</Tag>;
    } else {
      return <Tag severity="danger">Offline</Tag>;
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <>
        <Link className="mr-2" to={`/details/${rowData?.id}/0/1`}>
          View <FontAwesomeIcon icon={faEye} />
        </Link>
      </>
    );
  };

  const allowExpansion = (rowData) => {
    return Object.keys(rowData).length > 0;
  };

  const rowExpansionTemplate = (data) => {
    return (
      <div className="p-3">
        <DataTable value={data.modules} className="">
          <Column
            header="Sr no"
            body={(_, { rowIndex }) => rowIndex + 1}
            className="text-[14px] p-2 text-center "
          ></Column>
          <Column
            field="moduleName"
            header="Module name"
            className="text-[14px] p-2 text-center "
            sortable
          ></Column>
          {/* only for admin */}
          {role === 0 && (
            <Column
              field="tableName"
              header="Table name"
              className="text-[14px] p-2 text-center "
              sortable
            ></Column>
          )}
          <Column
            field="lastUpdated"
            header="Last Updated"
            className="text-[14px] p-2 text-center"
            sortable
          />
          <Column
            body={statusColumnBody}
            header="Status"
            className="text-[14px] p-2 text-center "
            sortable
          ></Column>
        </DataTable>
      </div>
    );
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;
    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const header = (
    <div className="flex justify-between">
      <p className="text-xl font-normal font-[sans-serif]">Device Status</p>
      <span className="flex items-center">
        <span className="font-normal">Search:</span>
        <InputText
          className="ml-1 p-1 text-sm font-normal border-1 border-gray-400"
          value={globalFilterValue}
          onChange={onGlobalFilterChange}
          placeholder="Keyword Search"
        />
      </span>
    </div>
  );

  return (
    <div className="main-panel">
      <div className="container-fluid py-3">
        <div className="height-100 bg">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 ">
              <div className="card caption-top ">
                <div className="p-3">
                  <div className="card">
                    <DataTable
                      value={isLoading ? [] : offline}
                      expandedRows={expandedRows}
                      onRowToggle={(e) => setExpandedRows(e.data)}
                      rowExpansionTemplate={rowExpansionTemplate}
                      dataKey="id"
                      header={header}
                      filters={filters}
                      tableStyle={{ minWidth: "60rem" }}
                      emptyMessage={
                        isLoading ? (
                          <p className="text-center">Loading...</p>
                        ) : (
                          "No Data Found"
                        )
                      }
                    >
                      <Column
                        expander={allowExpansion}
                        style={{ width: "5rem" }}
                      />
                      <Column
                        header="Sr no"
                        body={(_, { rowIndex }) => rowIndex + 1}
                        className="text-[14px] p-2 text-center text-nowrap"
                      />
                      <Column
                        field="node"
                        header="Node name"
                        className="text-[14px] p-2 text-center text-nowrap"
                        sortable
                      />
                      <Column
                        field="description"
                        header="Description"
                        className="text-[14px] p-2 text-center text-nowrap"
                        sortable
                      />
                      <Column
                        field="IOTLastUpdate"
                        header="IOT Last Update"
                        className="text-[14px] p-2 text-center text-nowrap"
                        sortable
                      />
                      <Column
                        // field="IOTStatus"
                        body={nodeStatusColumnBody}
                        header="IOT Status"
                        className="text-[14px] p-2 text-center text-nowrap"
                        sortable
                      />
                      <Column
                        field="location"
                        header="Location"
                        className="text-[14px] p-2 text-center text-nowrap"
                        sortable
                      />
                      <Column
                        body={actionBodyTemplate}
                        header="Action"
                        className="text-[14px] p-2 text-center text-nowrap"
                      />
                      {/* )} */}
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeviceStatus;
